<template>
  <div class="md:py-12 lg:py-12 py-6 mt-12 relative">
    <div class="absolute bg-design-mbr-ell mob-hidden">
      <img
        src="../../../assets/images/caregiver/mbr ell.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="absolute bg-design-mbr-ell2 mob-hidden">
      <img
        src="../../../assets/images/caregiver/mbr ell.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="absolute bg-design-mbr-poly-hcp mob-hidden">
      <img
        src="../../../assets/images/caregiver/mbr-poly.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="relative">
      <div class="">
        <div class="md:w-3/5 lg:w-2/5 w-3/5 bg-E3CEFF-mbr">
          <img
            src="../../../assets/images/caregiver/mbr-bg.svg"
            alt="bg polygon"
          />
        </div>
      </div>
      <div class="membership-negmt text-black z-10">
        <div
          class="md:w-4/5 lg:w-4/5 w-full px-4 md:px-0 lg:px-0 mt-8 mx-auto md:pt-12 lg:pt-12 pt-0"
        >
          <div
            class="md:pt-10 lg:pt-10 pt-2 grid md:grid-cols-3 lg:grid-cols-3 grid-cols-1 grid-rows-1 md:gap-12 lg:gap-12 gap-6 w-full"
          >
            <div
              class="col-span-2 bg-primary md:rounded-3xl lg:rounded-3xl rounded-xl md:p-8 lg:p-8 p-4 shadow-b-2xl relative trans-zoom-half"
            >
              <div>
                <div v-if="secondpage">
                  <validation-observer
                    v-slot="{ handleSubmit }"
                    ref="formValidator"
                  >
                    <b-form
                      role="form"
                      @submit.prevent="handleSubmit(handleSend)"
                    >
                      <div class="justify-between">
                        <p class="font-bold text-white fsize35-20 mb-2">
                          Request For Services
                        </p>

                        <p class="subtitle py-2 w-full fsize18-14-32px">
                          Kindly fill in the details below and we will get in
                          touch.
                        </p>
                      </div>
                      <div class="">
                        <p class="input-title">
                          Which services are you interested in
                        </p>
                        <multiselect
                          class="cust-hScroller"
                          v-model="value"
                          :options="options1"
                          :multiple="true"
                          :close-on-select="false"
                          :clear-on-select="false"
                          :preserve-search="true"
                          placeholder=""
                          label="name"
                          track-by="name"
                          :preselect-first="true"
                        >
                        </multiselect>
                      </div>
                      <div
                        class="pt-6 grid md:grid-cols-2 lg:grid-cols-2 grid-cols-1 grid-rows-2 gap-x-5 gap-y-2"
                      >
                        <div class="">
                          <p class="input-title">Name</p>
                          <base-input
                            v-model="fullname"
                            placeholder="Enter your name"
                            class="md:border-0 lg:border-0"
                            name="Name"
                            :rules="{ required: true }"
                          ></base-input>
                        </div>
                        <div class="">
                          <p class="input-title">Email Address</p>
                          <base-input
                            v-model="userData.email"
                            placeholder="Enter your EmailID"
                            class="md:border-0 lg:border-0"
                            name="Email"
                            :rules="{ required: true, email: true }"
                          ></base-input>
                        </div>
                        <div class="">
                          <p class="input-title">Contact No.</p>
                          <base-input
                            v-model="userData.mobile"
                            placeholder="Enter your Contact No."
                            class="md:border-0 lg:border-0"
                            name="Mobile no"
                            :rules="{ required: true }"
                          ></base-input>
                        </div>
                        <div class="">
                          <p class="input-title">City</p>
                          <base-input
                            v-model="location"
                            placeholder="Enter your Locality Name"
                            class="md:border-0 lg:border-0"
                            name="City"
                            :rules="{ required: true }"
                          ></base-input>
                        </div>
                      </div>
                      <div class="">
                        <p class="input-title">
                          Relationship with Care Recipient
                        </p>
                        <b-form-select v-model="selected">
                          <b-form-select-option
                            v-for="option in options"
                            :value="option"
                            :key="option._id"
                            name="Relationship"
                            :rules="{ required: true }"
                            >{{ option.text }}
                          </b-form-select-option></b-form-select
                        >
                      </div>

                      <div class="md:mt-4 mt-8 lg:mt-8 mb-12 bottom6-4 w-full">
                        <b-button
                          type="next"
                          variant="secondary"
                          class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 border-2 text-base font-bold"
                          @click="second()"
                          >Next</b-button
                        >
                      </div>
                    </b-form>
                  </validation-observer>
                </div>

                <div v-if="firstpage">
                  <Reg2Service />
                </div>

                <div class="flex justify-center">
                  <div class="custom-pagination">
                    <div
                      class="bg-white h-2 mr-4 w-16 cursor-pointer"
                      @click="first()"
                    ></div>
                    <div class="bg-primary h-1 w-16 cursor-pointer"></div>
                  </div>
                  <div class="custom-pagination">
                    <div
                      class="bg-white h-2 mr-4 w-16 cursor-pointer"
                      @click="second()"
                    ></div>
                    <div class="bg-primary h-1 w-16 cursor-pointer"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Reg2Service from "./Reg2Service.vue";
import emailMixin from "@/mixins/email";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";

export default {
  mixins: [emailMixin],
  data() {
    return {
      selected: null,
      value: "",
      firstpage: false,
      secondpage: true,
      fullname: "",
      name: "",
      options: [
        { value: null, text: "Please select an option" },
        { value: "a", text: "Primary Caregiver" },
        { value: "b", text: "Wellwisher" },
        { value: "c", text: "Long Distance Caregiver" },
      ],
      options1: [],

      relation: "",
      email: "",
      mobile: "",
      location: "",
      formData: {},
    };
  },

  components: {
    Reg2Service,
    Multiselect,
  },

  methods: {
    first() {
      this.firstpage = false;
      this.secondpage = true;
    },
    second() {
      this.formData = {
        name: this.fullname,
        relation: this.selected.text,
        email: this.userData.email,
        mobile: this.userData.mobile,
        location: this.location,
      };
      this.firstpage = true;
      this.secondpage = false;
      this.$store.commit("services/SET_REG", this.formData);
    },
    init() {
      this.$store.dispatch("eLearning/getProfile", {
        userId: this.userData._id,
      });
    },
  },
  mounted() {
    this.init();

    // console.log(this.profileData, "pdata");
    // console.log(this.userData, "udata");
    if (this.userData.firstname && this.userData.lastname) {
      this.fullname = this.userData.firstname + " " + this.userData.lastname;
    }

    this.$store.dispatch("services/getpartner");
    // console.log(this.get_AllPartner);
    this.get_AllPartner.forEach((x) => {
      const array = this.options1.push({
        name: x.title,
      });
    });
    // console.log(this.options1);
  },
  computed: {
    ...mapState("auth", ["userData"]),
    ...mapState("services", ["setregform"]),
    ...mapState("eLearning", ["profileData"]),
    ...mapState("services", { get_AllPartner: "get_AllPartner" }),

    isValidForm() {
      if (this.otp == "") {
        return true;
      } else if (
        this.name != "" &&
        this.email != "" &&
        this.designation != "" &&
        this.company != "" &&
        this.mobile != "" &&
        this.message != ""
      ) {
        return false;
      } else {
        return true;
      }
    },
    isdisabled() {
      if (this.status == "I have read and agreed to these") {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
